<template>
  <div class="riskTable">
    <div class=".aboveRiskTableHeaderButtons">
      <AddButton @clickEvent="addEntry"></AddButton>
    </div>

    <b-table :items="tableData" :fields="statusReportsRiskTableHeaders" striped>
      <template #cell(identifiedRisks)="data">
        <ValidationProvider
          v-slot="{ errors }"
          :vid="'identifiedRisks' + data.index"
          name="identifiedRisks"
          :rules="tableData[data.index].rules"
        >
          <TextArea
            :value="tableData[data.index].identifiedRisks"
            :style-type="style"
            :rows="rows"
            :placeholder="$t(tableData[data.index].identifiedRisksPlaceholder)"
            @input="tableData[data.index].identifiedRisks = $event"
          >
          </TextArea>

          <span class="statusReportsRiskTableErrorMessages">{{ errors[0] }}</span>
        </ValidationProvider>
      </template>

      <template #cell(cause)="data">
        <ValidationProvider v-slot="{ errors }" :vid="'cause' + data.index" name="cause" :rules="tableData[data.index].rules">
          <TextArea
            :value="tableData[data.index].cause"
            :style-type="style"
            :rows="rows"
            :placeholder="$t(tableData[data.index].causePlaceholder)"
            @input="tableData[data.index].cause = $event"
          >
          </TextArea>

          <span class="statusReportsRiskTableErrorMessages">{{ errors[0] }}</span>
        </ValidationProvider>
      </template>

      <template #cell(counterMeasures)="data">
        <ValidationProvider
          v-slot="{ errors }"
          :vid="'counterMeasures' + data.index"
          name="counterMeasures"
          :rules="tableData[data.index].rules"
        >
          <TextArea
            :value="tableData[data.index].counterMeasures"
            :style-type="style"
            :rows="rows"
            :placeholder="$t(tableData[data.index].counterMeasuresPlaceholder)"
            @input="tableData[data.index].counterMeasures = $event"
          >
          </TextArea>

          <span class="statusReportsRiskTableErrorMessages">{{ errors[0] }}</span>
        </ValidationProvider>
      </template>

      <template #cell(consequences)="data">
        <ValidationProvider v-slot="{ errors }" :vid="'consequences' + data.index" name="consequences" :rules="tableData[data.index].rules">
          <TextArea
            :value="tableData[data.index].consequences"
            :style-type="style"
            :rows="rows"
            :placeholder="$t(tableData[data.index].consequencesPlaceholder)"
            @input="tableData[data.index].consequences = $event"
          >
          </TextArea>

          <span class="statusReportsRiskTableErrorMessages">{{ errors[0] }}</span>
        </ValidationProvider>
      </template>

      <template #cell(delete)="data">
        <span v-if="data.index > 0" class="buttons">
          <span v-if="currentlyNotDeletingEntry(data)">
            <DeleteButton @clickEvent="promptToConfirmDelete(data)"></DeleteButton>
          </span>

          <span v-if="!currentlyNotDeletingEntry(data)">
            <ConfirmButton class="riskTableButtons" @clickEvent="confirmDelete(data)"></ConfirmButton>
          </span>

          <span v-if="!currentlyNotDeletingEntry(data)">
            <CancelButton @clickEvent="stopDeleting(data)"></CancelButton>
          </span>
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
import TextArea from '@/components/util/Inputs/TextArea'

import AddButton from '@/components/util/Buttons/TableButtons/AddButton'
import CancelButton from '@/components/util/Buttons/TableButtons/CancelButton'
import ConfirmButton from '@/components/util/Buttons/TableButtons/ConfirmButton'
import DeleteButton from '@/components/util/Buttons/TableButtons/DeleteButton'

import { editableTableMixin } from '../../../mixins/editableTableMixin'

import axios from '../../../../axios'

export default {
  name: 'StatusReportRiskTable',
  components: { TextArea, AddButton, CancelButton, ConfirmButton, DeleteButton },
  mixins: [editableTableMixin],
  props: {
    risks: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      localeConsts: {
        statusReportsIdentifiedRisks: 'STATUSREPORTS.RISK_IDENTIFIED',
        statusReportsCause: 'STATUSREPORTS.CAUSE',
        statusReportsCounterMeasures: 'STATUSREPORTS.COUNTER_MEASURES',
        statusReportsConsequences: 'STATUSREPORTS.CONSEQUENCES'
      },

      style: 'table',
      rows: 4,
      tableData: this.risks,
      riskIndex: this.risks.length
    }
  },

  computed: {
    statusReportsRiskTableHeaders() {
      return [
        {
          key: 'identifiedRisks',
          label: this.$i18n.t(this.localeConsts.statusReportsIdentifiedRisks),
          thClass: 'text-center statusReportsRiskTableStyle',
          tdClass: 'text-center'
        },

        {
          key: 'cause',
          label: this.$i18n.t(this.localeConsts.statusReportsCause),
          thClass: 'text-center statusReportsRiskTableStyle',
          tdClass: 'text-center'
        },

        {
          key: 'counterMeasures',
          label: this.$i18n.t(this.localeConsts.statusReportsCounterMeasures),
          thClass: 'text-center statusReportsRiskTableStyle',
          tdClass: 'text-center'
        },

        {
          key: 'consequences',
          label: this.$i18n.t(this.localeConsts.statusReportsConsequences),
          thClass: 'text-center statusReportsRiskTableStyle',
          tdClass: 'text-center'
        },

        { key: 'delete', label: '', thClass: 'text-center statusReportsRiskTableStyle', tdClass: 'text-center' }
      ]
    }
  },

  methods: {
    addEntry() {
      this.riskIndex++

      this.tableData.push({
        name: `risk${this.riskIndex}`,
        riskId: -1,
        identifiedRisks: '',
        cause: '',
        counterMeasures: '',
        consequences: '',
        identifiedRisksPlaceholder: 'STATUSREPORTS.RISK_IDENTIFIED_RISKS_PLACEHOLDER',
        causePlaceholder: 'STATUSREPORTS.RISK_CAUSE_PLACEHOLDER',
        counterMeasuresPlaceholder: 'STATUSREPORTS.RISK_COUNTER_MEASURES_PLACEHOLDER',
        consequencesPlaceholder: 'STATUSREPORTS.RISK_CONSEQUENCES_PLACEHOLDER',
        rules: 'required|max:1024',
        isDelete: false
      })
    },

    confirmDelete(entry) {
      if (this.tableData[entry.index].riskId !== -1) {
        axios.delete(`status-report-identified-risks/${this.tableData[entry.index].riskId}/`)
      }

      this.tableData.splice(entry.index, 1)
    }
  }
}
</script>

<style lang="scss">
$table-header-color: #451a6e;
$background-color: #c1afd1;
$error-text-color: red;

/*General table styling*/

.table .statusReportsRiskTableStyle {
  color: $table-header-color !important;
  background-color: $background-color !important;
}

//risk table buttons
.aboveRiskTableHeaderButtons {
  display: flex;
  margin-bottom: 15px;
  justify-content: space-between;
}

.buttons {
  display: flex;
}

.riskTableButtons {
  margin-right: 10px;
}

/*input error messages*/

.statusReportsRiskTableErrorMessages {
  color: $error-text-color;
  font-size: 12px;
}
</style>
